const { featureToggles = [] } = window.stacc_env

const getFormattedSimpleSearchFeatureToggles = () =>
  featureToggles
    .filter((s) => s.toString().startsWith('simpleSearch'))
    .map((s) => s.split('-'))
    .map((s) => s.slice(1).join('.'))

export default getFormattedSimpleSearchFeatureToggles
